// SEO metadata for each language
export const seoMetadata = {
    es: {
        title: "GYM TRACKER PRO - Seguimiento de Entrenamientos y Progreso | Offline",
        description: "App gratuita para seguimiento de entrenamientos en el gimnasio. Registra tus rutinas, pesas, series y repeticiones. Analiza tu progreso con estadísticas detalladas. Funciona offline.",
        keywords: "gym tracker pro, seguimiento entrenamientos, registro gimnasio, app tracking gym, seguimiento progreso muscular, registro pesas, app rutinas gym offline, estadísticas entrenamiento, log workout, fitness tracker español, seguimiento series repeticiones, progreso gym, workout log, gym diary, entrenamiento registro, strong alternativa, hevy alternativa"
    },
    en: {
        title: "GYM TRACKER PRO - Workout Tracking & Progress | Offline",
        description: "Free app for tracking gym workouts. Log your routines, weights, sets and reps. Analyze your progress with detailed statistics. Works offline.",
        keywords: "gym tracker pro, workout tracking, gym log, fitness tracker app, progress tracking, weight lifting log, offline gym app, workout statistics, exercise log, fitness tracker, sets reps tracking, gym progress, workout diary, training log, strong alternative, hevy alternative"
    },
    fr: {
        title: "GYM TRACKER PRO - Suivi d'Entraînement et Progrès | Hors ligne",
        description: "Application gratuite pour suivre vos entraînements en salle de sport. Enregistrez vos routines, poids, séries et répétitions. Analysez vos progrès avec des statistiques détaillées. Fonctionne hors ligne.",
        keywords: "gym tracker pro, suivi entraînement, journal gym, application fitness, suivi progrès, journal musculation, app gym hors ligne, statistiques entraînement, log workout, tracker fitness, suivi séries répétitions, progrès gym, journal entraînement, strong alternative, hevy alternative"
    },
    de: {
        title: "GYM TRACKER PRO - Trainings-Tracking & Fortschritt | Offline",
        description: "Kostenlose App zum Verfolgen von Gym-Workouts. Protokollieren Sie Ihre Routinen, Gewichte, Sätze und Wiederholungen. Analysieren Sie Ihren Fortschritt mit detaillierten Statistiken. Funktioniert offline.",
        keywords: "gym tracker pro, trainings tracking, gym protokoll, fitness tracker app, fortschritt tracking, krafttraining log, offline gym app, trainingsstatistiken, übungsprotokoll, fitness tracker, sätze wiederholungen tracking, gym fortschritt, trainings tagebuch, strong alternative, hevy alternative"
    },
    it: {
        title: "GYM TRACKER PRO - Monitoraggio Allenamenti e Progressi | Offline",
        description: "App gratuita per monitorare gli allenamenti in palestra. Registra le tue routine, pesi, serie e ripetizioni. Analizza i tuoi progressi con statistiche dettagliate. Funziona offline.",
        keywords: "gym tracker pro, monitoraggio allenamenti, registro palestra, app fitness tracker, monitoraggio progressi, registro pesi, app palestra offline, statistiche allenamento, log workout, fitness tracker, monitoraggio serie ripetizioni, progressi palestra, diario allenamento, strong alternativa, hevy alternativa"
    },
    pt: {
        title: "GYM TRACKER PRO - Rastreamento de Treinos e Progresso | Offline",
        description: "App gratuito para rastrear treinos na academia. Registre suas rotinas, pesos, séries e repetições. Analise seu progresso com estatísticas detalhadas. Funciona offline.",
        keywords: "gym tracker pro, rastreamento treinos, registro academia, app fitness tracker, rastreamento progresso, registro pesos, app academia offline, estatísticas treino, log workout, fitness tracker, rastreamento séries repetições, progresso academia, diário treino, strong alternativa, hevy alternativa"
    }
};

// Update document metadata based on current language
export const updateSEOMetadata = (language) => {
    const metadata = seoMetadata[language] || seoMetadata.en;

    // Update title
    document.title = metadata.title;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
        metaDescription.setAttribute('content', metadata.description);
    }

    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
        metaKeywords.setAttribute('content', metadata.keywords);
    }

    // Update Open Graph title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
        ogTitle.setAttribute('content', metadata.title);
    }

    // Update Open Graph description
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
        ogDescription.setAttribute('content', metadata.description);
    }

    // Update Twitter title
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) {
        twitterTitle.setAttribute('content', metadata.title);
    }

    // Update Twitter description
    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) {
        twitterDescription.setAttribute('content', metadata.description);
    }

    // Update html lang attribute
    document.documentElement.setAttribute('lang', language);
};
